import { render, staticRenderFns } from "./publicTransferAudit.vue?vue&type=template&id=27e8ba03&scoped=true"
import script from "./publicTransferAudit.vue?vue&type=script&lang=js"
export * from "./publicTransferAudit.vue?vue&type=script&lang=js"
import style0 from "./publicTransferAudit.vue?vue&type=style&index=0&id=27e8ba03&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27e8ba03",
  null
  
)

export default component.exports